import { InjectionToken } from '@angular/core';

import { ChatAiDemoTitle, ChatAiTitle, PageTitle } from 'src/app/_services/title/title.service';

export interface IChatAiComponentConfig {
    storageKey: string;
    shouldLoadDefaultMessage: boolean;
    title: PageTitle[];
}

export const CHAT_AI_COMPONENT_CONFIG: InjectionToken<IChatAiComponentConfig> =
    new InjectionToken<IChatAiComponentConfig>('chat ai component configuration');

export const CHAT_AI_SERVER_CONFIG: IChatAiComponentConfig = {
    storageKey: 'chat_ai_server_messages_history',
    shouldLoadDefaultMessage: false,
    title: ChatAiTitle
};

export const CHAT_AI_DEMO_CONFIG: IChatAiComponentConfig = {
    storageKey: 'chat_ai_demo_messages_history',
    shouldLoadDefaultMessage: true,
    title: ChatAiDemoTitle
};
